import { useContext, useState } from 'react';
import styles from './ConfirmationBooking.module.scss';
import ButtonWithIcon from '../ButtonWithIcon/ButtonWithIcon';

import { ApplicationContext } from '../../context/ApplicationContext';
const ConfirmationBooking = ({
    date,
    bookingTime,
    booked,
    setBooked,
    dataContent,
    brandName,
    phone,
    contact,
    formData,
    message,
    type,
    language,
    brandId,
    categories,
    dataLang
}) => {
    const { setShowLoader } = useContext(ApplicationContext)
    const { name, lastname, email, customer_title } = formData
    const splitStartTime = `${bookingTime}`.split(':');
    const endTime = parseInt(splitStartTime[1]) === 0 ? `${parseInt(splitStartTime[0])}:30:00` : `${parseInt(splitStartTime[0]) + 1}:00:00`
    const options = { year: 'numeric', month: 'long', day: 'numeric' }
    const formatDate = date && new Date(date).toLocaleDateString(dataLang, options);


    const confirmBooking = async () => {
        setShowLoader(true);
        const res = await fetch(`${process.env.NEXT_PUBLIC_FE_BOOKING}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                appointment_type: "onsite",
                customer_timezone: "Europe/Rome",
                date: `${date}`,
                email: email,
                customer_title: customer_title,
                end_time: endTime,
                first_name: name,
                last_name: lastname,
                mall: "TMS",
                nl_subscribe: 0,
                notes: message,
                phone_num: `${phone}`,
                preferred_contact: contact,
                preferred_language: language,
                product_category: categories,
                service_id: `${brandId}`,
                start_time: `${bookingTime}:00`,
                status: 0,
                tmqAccount: email,
            }),
        })
        const resjs = await res.json();
        setShowLoader(false);
        if (resjs.result === 'CONFIRMED') {
            setBooked(true)
        }
    }


    return (
        <div className={styles.container}>
            {!booked &&
                <>
                    <div>
                        <h6>{brandName}</h6>
                        <p>{dataContent.step1.day} <span> {formatDate}</span></p>
                        <p>{dataContent.step1.time}<span> {bookingTime}</span></p>
                        <p>{dataContent.step2.items[3].field.placeholder}<span> {phone}</span></p>
                        <p>{dataContent.step2.items[4].field.placeholder}<span> {type}</span></p>
                        <p>{dataContent.step2.items[5].field.placeholder} <span>{contact}</span></p>
                        <p>{dataContent.step3.title_location} <span> {process.env.NEXT_PUBLIC_LOCATION}</span></p>
                    </div>
                    <div className={styles.confirmation}>

                        <ButtonWithIcon onClick={() => confirmBooking()} link={{ title: dataContent.step3.cta_title_confirm }} />

                    </div>
                </>
            }
            {booked &&
                <div style={{ textAlign: 'center' }}>
                    <h6>{dataContent.step4.title}</h6>
                    <p dangerouslySetInnerHTML={{ __html: dataContent.step4.text }}></p>
                </div>
            }
        </div>
    )
}

export default ConfirmationBooking;